// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","navButton":"_1CVF3yjEkIef7-ZHSPdU-H","currentPage":"_2rwZl102P8VQUFTa5KWmL6","disabled":"_2pFkvFEkZIUAfk1N7FiSxu","paginationArea":"_3aedjiOMTtaxTNDh8DZqXZ"};